import { Button } from 'antd';
import { IPublicClientApplication } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';

const LogoutButton = () => {
  const { instance } = useMsal();

  function handleLogout(instance: IPublicClientApplication) {
    instance.logoutRedirect().catch((e: string) => {
      console.error(e);
    });
  }

  return (
    <Button
      type="primary"
      block
      onClick={() => {
        handleLogout(instance);
      }}
    >
      Log Out
    </Button>
  );
};

export default LogoutButton;
